import { ReactComponent as TemplateIcon } from "assets/svg/coverSong.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const coverSong: SurveyTemplate = {
  icon: <TemplateIcon />,
  title: "Cover Song",
  description:
    "Enable your fans to vote for the cover song you'll be trying on today's live.",
  templateId: "coverSong",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "Cover Song",
        },
      },
      ...getContestDefaults(formState),
    },
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-livestream-19e70a"
        : "pp-livestream-e96e6e",
    fields: [
      {
        name: "date",
        type: "text",
        label: "When does your livestream take place?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.date ? false : "This field cannot be left blank",
      },
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
